import TemplateView from '../../TemplateView'

export default class Toast extends TemplateView {
    constructor({
        innerHtml = '',
        additionalClass = '',
        withCloseIcon = false,
        onClose = () => {},
    }) {
        super()

        this.params = {
            innerHtml,
            additionalClass,
            withCloseIcon,
            onClose,
        }
    }

    templateHtml() {
        return "<div class='toastWrapper'>" +
               "    <div class='toast <%=additionalClass%>'>" +
               "        <span class='innerHtml'><%=innerHtml%></span>" +
               "        <span class='closeIcon'></span>" +
               "    </div>" +
               "</div>"
    }

    templateModel() {
        return {
            innerHtml: this.params.innerHtml,
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.$el.atAnimation().fadeIn()

        if (this.params.withCloseIcon) {
            this.find('.closeIcon').click(() => this.params.onClose())
        }
    }

    hide() {
        this.$el.atAnimation().hideAnimated('anim-hide-toast', () => this.$el.remove())
    }
}



// WEBPACK FOOTER //
// ./web/js/toasts/components/Toast.js